<template lang='pug'>
  .bf-flex.component
    slot
</template>

<script>
  export default {
    name: 'bf-flex'
  }
</script>

<style scoped lang='stylus'>
  .bf-flex
    display flex

  .bf-flex.centered
    align-items center
    justify-content center
  
  .bf-flex.left
    align-items center

  .bf-flex.space-between
    justify-content space-between

  .bf-flex.space-evenly
    justify-content space-evenly

  .bf-flex.column
    flex-direction column

  .bf-flex.block
    width 100%

  .bf-flex.full
    width 100%
    height 100vh

  .bf-flex.fixed
    position fixed
    top 0
    left 0
    &.bottom
      top auto
      bottom 0
</style>
